import axios from "axios";
import { API_URL } from "./constants";

const API = axios.create({
  baseURL: `${API_URL[process.env.NODE_ENV]}`,
  timeout: 10000,
  headers: {
    authorization: `Bearer ${localStorage.getItem("accesstokenhotelparkmall")}`,
  },
});

export default API;
